export const SERVICES = [
  {
    id: 'residential',
    title: 'Residential Interior Design',
    description:
      "Complete home transformations that blend modern aesthetics with Indian cultural elements, creating spaces that reflect your family's unique story.",
    detailedDescription:
      "Our residential interior design service offers comprehensive home transformation solutions that honor Indian family lifestyles while embracing contemporary design principles. We specialize in creating culturally-informed layouts that optimize space utilization and energy flow, incorporating traditional craftsmanship with modern functionality. From conceptualization to execution, we manage every aspect of your home's interior journey.",
    features: [
      'Space planning and layout optimization',
      'Custom furniture design with local artisan collaboration',
      'Traditional Indian textile and material integration',
      'Climate-appropriate material selection for Indian homes',
      'Multi-generational living space considerations',
      'Festival and celebration space planning',
      'Smart home integration with traditional aesthetics',
      'Sustainable and locally-sourced material prioritization',
    ],
    image: '/assets/Living.jpg',
    alt: 'Modern Indian living room with traditional jali screen partition, contemporary furniture, and warm ambient lighting',
    icon: 'HomeIcon',
    priceRange: '₹18,00,000 - ₹35,00,000',
    timeline: '3-6 months',
    scope: 'Complete Home',
    process: [
      'Initial consultation and family lifestyle assessment',
      'Site analysis and space planning with 3D visualization',
      'Material selection with local vendor coordination',
      'Custom furniture design and artisan collaboration',
      'Execution with weekly progress updates',
      'Final styling and handover with maintenance guide',
    ],
    gallery: [
      { image: '/services/residential-1.webp', alt: 'Spacious living room with traditional Indian decor elements and modern furniture' },
      { image: '/services/residential-2.webp', alt: 'Contemporary dining area with Indian artwork and handcrafted furniture' },
      { image: '/services/residential-3.jpg', alt: 'Cozy bedroom with Indian textiles and modern design' },

      { image: '/services/residential-4.webp', alt: 'Modern Indian home office with traditional decor accents' },
      
      
    ],
  },
  {
    id: 'modular',
    title: 'Modular Solutions',
    description:
      'Intelligent modular kitchens, wardrobes, and storage systems designed specifically for Indian cooking styles and family storage needs.',
    detailedDescription:
      'Our modular solutions are engineered for Indian lifestyles, with specialized designs for masala storage, pressure cooker organization, and extensive utensil management. We understand the unique requirements of Indian kitchens and create storage systems that accommodate everything from traditional cookware to modern appliances, all while maintaining aesthetic excellence.',
    features: [
      'Indian cooking-optimized kitchen layouts',
      'Specialized masala and spice storage systems',
      'Pressure cooker and heavy utensil organization',
      'Moisture-resistant materials for Indian climate',
      'Extensive storage for Indian cookware variety',
      'Modular wardrobes with saree and ethnic wear sections',
      'Customizable storage for joint family needs',
      'Easy-maintenance surfaces for daily Indian cooking',
    ],
    image: '/home/kitchen.png',
    alt: 'Modern modular kitchen with organized spice drawers, pressure cooker storage, and contemporary Indian cooking setup',
    icon: 'Squares2X2Icon',
    priceRange: '₹2,50,000 - ₹8,00,000',
    timeline: '6-10 weeks',
    scope: 'Kitchen/Wardrobes',
    process: [
      'Space measurement and cooking habit analysis',
      'Custom design with Indian storage requirements',
      'Material selection for durability and maintenance',
      'Factory fabrication with quality checks',
      'Professional installation and fitting',
      'Usage training and warranty activation',
    ],
    gallery: [
      { image: '/services/modular-1.png', alt: 'Modular kitchen with pull-out spice racks and organized storage' },
      { image: '/services/modular-2.png', alt: 'Contemporary wardrobe with dedicated saree storage section' },
      { image: 'https://images.unsplash.com/photo-1628745277874-919d8f8ed03a', alt: 'Kitchen island with Indian cooking appliance storage' },
    ],
  },
  {
    id: 'luxury',
    title: 'Luxury Styling',
    description:
      'Curated furniture selection and textile styling that brings together global luxury with Indian craftsmanship and cultural authenticity.',
    detailedDescription:
      'Our luxury styling service is a carefully orchestrated curation of furniture, textiles, and decorative elements that celebrate Indian heritage while embracing contemporary luxury. We source from master craftspeople across India, combining traditional techniques like hand-block printing, zardozi embroidery, and brass inlay work with modern design sensibilities to create truly unique spaces.',
    features: [
      'Curated furniture from Indian master craftspeople',
      'Traditional textile integration (Banarasi, Kanjivaram, Ikat)',
      'Handcrafted brass and copper accent pieces',
      'Contemporary interpretation of traditional motifs',
      'Luxury fabric selection for Indian climate',
      'Artisan collaboration for custom pieces',
      'Heritage craft preservation through modern design',
      'Investment-grade furniture and art curation',
    ],
    image: '/home/luxury-styling.jpg',
    alt: 'Luxurious living room with handcrafted Indian furniture, silk textiles, and brass decorative elements',
    icon: 'SparklesIcon',
    priceRange: '₹5,00,000 - ₹15,00,000',
    timeline: '8-12 weeks',
    scope: 'Styling & Furnishing',
    process: [
      'Lifestyle and aesthetic preference consultation',
      'Artisan and vendor sourcing across India',
      'Custom furniture and textile design',
      'Quality inspection and approval',
      'Professional installation and styling',
      'Final touches and photography session',
    ],
    gallery: [
      { image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1c4108f1b-1765014601557.png', alt: 'Bedroom with handwoven Banarasi silk bedding and carved wooden furniture' },
      { image: 'https://img.rocket.new/generatedImages/rocket_gen_img_182992347-1765021095393.png', alt: 'Living area with traditional Indian brass lamps and contemporary seating' },
    ],
  },
  {
    id: 'renovation',
    title: 'Renovation & Restoration',
    description:
      'Heritage home modernization that preserves architectural character while upgrading functionality for contemporary Indian family living.',
    detailedDescription:
      'Our renovation and restoration service specializes in breathing new life into heritage properties and older homes while respecting their architectural integrity. We understand the emotional connection Indian families have with ancestral homes and work to preserve original elements like carved woodwork, traditional flooring, and architectural details while introducing modern amenities and improved functionality.',
    features: [
      'Heritage architecture preservation and documentation',
      'Traditional element restoration (carved wood, jali work)',
      'Modern amenity integration without character loss',
      'Structural assessment and reinforcement',
      'Original material matching and sourcing',
      'Climate control and moisture management',
      'Electrical and plumbing modernization',
      'Compliance with heritage building regulations',
    ],
    image: '/renovation.jpeg',
    alt: 'Restored heritage home interior with preserved carved wooden pillars, updated lighting, and modern amenities',
    icon: 'WrenchScrewdriverIcon',
    priceRange: '₹15,00,000 - ₹40,00,000',
    timeline: '4-8 months',
    scope: 'Renovation Project',
    process: [
      'Heritage assessment and documentation',
      'Structural evaluation and planning',
      'Material sourcing and craftsperson coordination',
      'Phased execution with minimal disruption',
      'Quality restoration of original elements',
      'Modern system integration and final handover',
    ],
    gallery: [
      
    ],
  },
  {
    id: 'turnkey',
    title: 'Turnkey Projects',
    description:
      'End-to-end project management from concept to completion, perfect for NRI families and busy professionals seeking hassle-free home creation.',
    detailedDescription:
      'Our turnkey project service offers complete peace of mind with comprehensive project management from initial design through final handover. Ideal for NRI families and busy professionals, we handle every aspect including vendor coordination, quality control, timeline management, and regular progress updates. You receive a fully finished, move-in ready home without the stress of managing multiple contractors.',
    features: [
      'Single-point contact for entire project',
      'Comprehensive vendor and contractor management',
      'Weekly progress reports with photos and videos',
      'Quality control at every project stage',
      'Timeline and budget adherence guarantee',
      'Remote collaboration tools for NRI clients',
      'Material procurement and quality verification',
      'Post-completion support and warranty management',
    ],
    image: '/assets/Foyer-Area.jpg',
    alt: 'Completed turnkey project showing fully furnished modern Indian home ready for move-in',
    icon: 'KeyIcon',
    priceRange: '₹25,00,000 - ₹60,00,000',
    timeline: '4-7 months',
    scope: 'Complete Turnkey',
    process: [
      'Comprehensive project planning and budgeting',
      'Design development with client approvals',
      'Vendor selection and contract management',
      'Execution with regular progress updates',
      'Quality inspections and issue resolution',
      'Final handover with complete documentation',
    ],
    gallery: [
      { image: 'https://img.rocket.new/generatedImages/rocket_gen_img_14ed6c91b-1765159449514.png', alt: 'Completed living room in turnkey project with all furnishings' },
    ],
  },
  {
    id: 'consultation',
    title: 'Consultation Services',
    description:
      'Expert design guidance for homeowners who want clarity, confidence, and professional direction while managing their own projects.',
    detailedDescription:
      'Our consultation service provides expert design guidance and planning support for homeowners who prefer to manage their own projects but want professional expertise. We offer comprehensive design plans, material recommendations, vendor suggestions, and ongoing advisory support to ensure your project stays on track and achieves professional results.',
    features: [
      'Comprehensive design plan and layout drawings',
      'Material selection guidance and sourcing support',
      'Vendor and contractor recommendations',
      'Budget planning and cost optimization',
      'Design consultation and space planning',
      'Color scheme and styling recommendations',
      'Ongoing advisory support during execution',
      'Quality check visits and issue resolution',
    ],
    image: '/home/consultation.png',
    alt: 'Interior design consultation meeting with floor plans, material samples, and color swatches on table',
    icon: 'ChatBubbleLeftRightIcon',
    priceRange: '₹50,000 - ₹2,00,000',
    timeline: '2-4 weeks',
    scope: 'Advisory Services',
    process: [
      'Initial consultation and requirement gathering',
      'Site visit and space assessment',
      'Design plan and material recommendation',
      'Vendor list and budget breakdown',
      'Periodic site visits during execution',
      'Final review and completion support',
    ],
    gallery: [
      { image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1ba2ccb83-1764654287897.png', alt: 'Design consultation with material boards and floor plans' },
    ],
  },
  {
    id: 'flooring',
    title: 'False Ceiling & Flooring (Epoxy)',
    description: ' Elegant false ceilings and seamless epoxy flooring that elevate everyday living with modern character.',
    detailedDescription: 'We provide high-quality epoxy flooring and modern false ceiling solutions that are durable, low-maintenance and visually striking. Our systems integrate concealed lighting, service access panels, and acoustic treatments where required. Ideal for living areas, showrooms and modern apartments.',
    features: [
      '3D epoxy floor finishes',
      'Seamless, low-maintenance surfaces',
      'POP & gypsum false ceilings',
      'Integrated concealed lighting and ducts',
    ],
    image: '/home/flooring.jpg',
    alt: 'Epoxy flooring with modern false ceiling and integrated lighting',
    icon: 'Square3Stack3DIcon',
    priceRange: '₹75,000 - ₹5,00,000',
    timeline: '2-6 weeks',
    scope: 'Flooring & Ceiling',
    process: [
      'Site assessment and substrate preparation',
      'Material selection and color mockups',
      'Professional installation and curing',
      'Final inspection and maintenance briefing',
    ],
    gallery: [
      
      { image: '/services/ceiling-1.jpeg', alt: 'Modern false ceiling with integrated LED lighting' },
      { image: '/services/ceiling-2.jpeg', alt: 'Contemporary living room with gypsum false ceiling design' },
      { image: '/services/ceiling-3.jpeg', alt: 'False ceiling with cove lighting and modern design' },
      { image: '/services/ceiling-4.jpeg', alt: 'High-gloss epoxy flooring in residential living area' },
      { image: '/services/ceiling-5.jpeg', alt: 'Textured epoxy flooring with custom design pattern' },
    ],
  },
  {
    id: 'lighting',
    title: 'Lighting (Specialists & Smart Lights)',
    description: 'Thoughtfully designed lighting layered, ambient, and smart to shape mood, comfort, and functionality.',
    detailedDescription: 'Our lighting specialists deliver curated lighting plans that combine ambient, task and accent lighting with smart automation. We specify fixtures, control systems and energy-efficient LED solutions tailored for Indian daylight and climate conditions.',
    features: [
      'Ambient, task & accent lighting design',
      'Smart lighting automation and scenes',
      'Energy-efficient LED solutions',
      'Fixture selection and placement',
    ],
    image: '/home/lighting.jpg',
    alt: 'Thoughtful layered lighting in a modern Indian living room',
    icon: 'LightBulbIcon',
    priceRange: '₹30,000 - ₹4,00,000',
    timeline: '2-6 weeks',
    scope: 'Lighting Design & Controls',
    process: [
      'Lighting audit and needs assessment',
      'Fixture selection and mockups',
      'Smart control configuration and commissioning',
      'Training and handover',
    ],
    gallery: [
      { image: '/home/lighting.jpg', alt: 'Layered lighting with warm LEDs' },
       { image: '/services/lighting-1.jpg', alt: 'Smart home control panel with voice assistant' },
      { image: '/services/lighting-2.jpg', alt: 'Automated lighting system with mobile app control' },
      { image: '/services/lighting-3.png', alt: 'Smart thermostat integrated with home automation system' },
    ],
  },
  {
    id: 'automation',
    title: 'Home Automation & Smart Devices',
    description: 'Intelligent home automation powered by Alexa so your lighting, climate, and comfort respond effortlessly to you. ',
    detailedDescription: 'We integrate smart home ecosystems including voice assistants, smart switches, lighting, climate controls and security systems. Our solutions focus on ease-of-use, interoperability and minimal visual impact, allowing traditional interiors to remain the focal point.',
    features: [
      'Alexa & voice assistant integration',
      'Smart switches & central hubs',
      'Automations & scheduling',
      'Mobile app control & monitoring',
    ],
    image: '/automation-image.png',
    alt: 'Smart home control panel and automated lighting',
    icon: 'CpuChipIcon',
    priceRange: '₹25,000 - ₹3,00,000',
    timeline: '1-4 weeks',
    scope: 'Automation & Controls',
    process: [
      'Requirement mapping and ecosystem design',
      'Hardware selection and wiring plan',
      'Installation and automation setup',
      'User training and warranty support',
    ],
    gallery: [
      { image: '/assets/automation.jpg', alt: 'Home automation hub and devices' },
     


    ],
  },
];

export default SERVICES;
